import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FileDropZone } from "../../_metronic/layout/components/dropzone/FileDropZone";
import FormFooterButtons from "../components/FormFooterButtons";
import { Card } from "react-bootstrap";
import {
    wardList,
    toleWardOne,
    toleWardTwo,
    toleWardThree,
    toleWardFour,
    toleWardFive,
    toleWardSix,
    toleWardSeven,
    toleWardEight,
    toleWardTen,
    toleWardNine,
    toleWardEleven,
    toleWardTwelve,
} from "../data/ToleList";
import {
    toleFiveQn,
    toleFourQn,
    toleOneQn,
    toleThreeQn,
    toleTwoQn,
    toleSixQn,
    toleSevenQn,
    toleEightQn,
    toleNineQn,
    toleTenQn,
    toleElevenQn,
    toleTwelveQn,
} from "../data/houseSurvey";
import {
    ward,
    religiousList,
    wardQuestion,
    selectedLanguage,
} from "../data/institute";
import ImageUploader from "../components/ImageUploader";

const HistoricalReligiousSite = (props) => {
    const [selectedWard, setSelectedWard] = useState(0);

    const wardData = [
        {
            question: toleOneQn,
            toleList: toleWardOne,
        },
        {
            question: toleTwoQn,
            toleList: toleWardTwo,
        },
        {
            question: toleThreeQn,
            toleList: toleWardThree,
        },
        {
            question: toleFourQn,
            toleList: toleWardFour,
        },
        {
            question: toleFiveQn,
            toleList: toleWardFive,
        },
        {
            question: toleSixQn,
            toleList: toleWardSix,
        },
        {
            question: toleSevenQn,
            toleList: toleWardSeven,
        },
        {
            question: toleEightQn,
            toleList: toleWardEight,
        },
        {
            question: toleNineQn,
            toleList: toleWardNine,
        },
        {
            question: toleTenQn,
            toleList: toleWardTen,
        },
        {
            question: toleElevenQn,
            toleList: toleWardEleven,
        },
        {
            question: toleTwelveQn,
            toleList: toleWardTwelve,
        },
    ];
    const getToleList = (ward) => {
        if (ward == 1) {
            return toleWardOne;
        } else if (ward == 2) {
            return toleWardTwo;
        } else if (ward == 3) {
            return toleWardThree;
        } else if (ward == 4) {
            return toleWardFour;
        } else if (ward == 5) {
            return toleWardFive;
        } else if (ward == 6) {
            return toleWardSix;
        } else if (ward == 7) {
            return toleWardSeven;
        } else if (ward == 8) {
            return toleWardEight;
        } else if (ward == 9) {
            return toleWardNine;
        } else if (ward == 10) {
            return toleWardTen;
        } else if (ward == 11) {
            return toleWardEleven;
        } else {
            return toleWardTwelve;
        }
    };
    const handleWardChange = (ward) => {
        setSelectedWard(ward);
    };
    return (
        <div>
            <Formik
                enableReinitialize
                initialValues={
                    props.data
                        ? props.data
                        : {
                              name: "",
                              wardNumber: "",
                              toleName: "",
                              streetName: "",
                              establishedDate: "",
                              isGuthiInvolved: "",
                              isCommitteeFormed: "",
                              committeeName: "",
                              sponsorPersonInfoName: "",
                              sponsorPersonInfoContact: "",
                              historicalLegend: "",
                              capacity: "",
                          }
                }
                validate={(values) => {
                    const errors = {};
                    // if (!values.name) {
                    //     errors.name = 'Required';
                    // }
                    // else
                    // if (
                    //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                    // ) {
                    //     errors.email = 'Invalid email address';
                    // }
                    return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                    console.log(values);
                    setTimeout(() => {
                        props.submit(values);
                        setSubmitting(false);
                    }, 400);
                }}
            >
                {({
                    values,
                    touched,
                    errors,
                    dirty,
                    isSubmitting,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    handleReset,
                }) => (
                    <>
                        <form
                            className="form survey-form"
                            onSubmit={handleSubmit}
                        >
                            <Card>
                                <Card.Body>
                                    <div className="form-group row">
                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                सम्पदाको नाम
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="सम्पदाको नाम"
                                                name="name"
                                                onChange={handleChange}
                                                value={values.name}
                                            />
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="name"
                                                component="div"
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                {wardQuestion[selectedLanguage]}
                                            </label>
                                            <select
                                                className="form-control"
                                                id="wardNumber"
                                                name="wardNumber"
                                                onChange={handleChange}
                                                handleWardChange={handleWardChange(
                                                    values.wardNumber
                                                )}
                                                value={
                                                    values.wardNumber
                                                        ? values.wardNumber
                                                        : "selectOne"
                                                }
                                            >
                                                <option
                                                    value="selectOne"
                                                    disabled
                                                >
                                                    कुनै एक छान्नुहोस्
                                                </option>
                                                {wardList.map((woda) => (
                                                    <option value={woda.value}>
                                                        {woda[selectedLanguage]}
                                                    </option>
                                                ))}
                                            </select>
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="wardNumber"
                                                component="div"
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        {values.wardNumber && (
                                            <div className="col-md-6">
                                                <label className="form-control-label">
                                                    {
                                                        wardData[
                                                            values.wardNumber -
                                                                1
                                                        ].question[
                                                            selectedLanguage
                                                        ]
                                                    }
                                                </label>
                                                <select
                                                    className="form-control"
                                                    id="toleName"
                                                    name="toleName"
                                                    onChange={handleChange}
                                                    value={
                                                        values.toleName
                                                            ? values.toleName
                                                            : "selectOne"
                                                    }
                                                >
                                                    <option
                                                        value="selectOne"
                                                        disabled
                                                    >
                                                        कुनै एक छान्नुहोस्
                                                    </option>
                                                    {getToleList(
                                                        values.wardNumber
                                                    ).map((woda) => (
                                                        <option
                                                            value={woda.value}
                                                        >
                                                            {
                                                                woda[
                                                                    selectedLanguage
                                                                ]
                                                            }
                                                        </option>
                                                    ))}
                                                </select>
                                                <ErrorMessage
                                                    className="invalid-feedback"
                                                    name="toleName"
                                                    component="div"
                                                />
                                            </div>
                                        )}

                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                मार्गको नाम
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="मार्गको नाम"
                                                name="streetName"
                                                onChange={handleChange}
                                                value={values.streetName}
                                            />
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="streetName"
                                                component="div"
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                धार्मिक, सांस्कृतिक तथा एतिहासिक
                                                स्थलको प्रकार
                                            </label>
                                            <select
                                                className="form-control"
                                                id="placeType"
                                                name="placeType"
                                                onChange={handleChange}
                                                value={
                                                    values.placeType
                                                        ? values.placeType
                                                        : "selectOne"
                                                }
                                            >
                                                <option
                                                    value="selectOne"
                                                    disabled
                                                >
                                                    कुनै एक छान्नुहोस्
                                                </option>
                                                {religiousList.map(
                                                    (religious) => (
                                                        <option
                                                            value={
                                                                religious.value
                                                            }
                                                        >
                                                            {
                                                                religious[
                                                                    selectedLanguage
                                                                ]
                                                            }
                                                        </option>
                                                    )
                                                )}
                                            </select>
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="placeType"
                                                component="div"
                                            />
                                        </div>

                                        {values.placeType == "other" && (
                                            <div className="col-md-6">
                                                <label className="form-control-label">
                                                    अन्य भए उल्लेख गर्नुहोस्
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="अन्य भए उल्लेख गर्नुहोस्"
                                                    name="placeTypeOther"
                                                    onChange={handleChange}
                                                    value={
                                                        values.placeTypeOther
                                                    }
                                                />
                                                <ErrorMessage
                                                    className="invalid-feedback"
                                                    name="placeTypeOther"
                                                    component="div"
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                स्थापना मिति (2070-10-12) (साल
                                                -महिना -दिन )
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="स्थापना मिति (2070-10-12) (साल -महिना -दिन )"
                                                name="establishedDate"
                                                onChange={handleChange}
                                                value={values.establishedDate}
                                            />
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="establishedDate"
                                                component="div"
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                सञ्चालनको लागि गुठी
                                            </label>
                                            <label class="radio radio-rounded">
                                                <input
                                                    type="radio"
                                                    value="yes"
                                                    name="isGuthiInvolved"
                                                    onChange={handleChange}
                                                />
                                                <span></span>छ
                                            </label>
                                            <label class="radio radio-rounded">
                                                <input
                                                    type="radio"
                                                    value="no"
                                                    name="isGuthiInvolved"
                                                    onChange={handleChange}
                                                />
                                                <span></span>
                                                छैन
                                            </label>
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="isGuthiInvolved"
                                                component="div"
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                सन्चाल समिति गठन गरेको छ कि छैन
                                                ?
                                            </label>
                                            <label class="radio radio-rounded">
                                                <input
                                                    type="radio"
                                                    value="yes"
                                                    name="isCommitteeFormed"
                                                    onChange={handleChange}
                                                />
                                                <span></span>छ
                                            </label>
                                            <label class="radio radio-rounded">
                                                <input
                                                    type="radio"
                                                    value="no"
                                                    name="isCommitteeFormed"
                                                    onChange={handleChange}
                                                />
                                                <span></span>
                                                छैन
                                            </label>
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="isCommitteeFormed"
                                                component="div"
                                            />
                                        </div>

                                        {values.isCommitteeFormed == "yes" && (
                                            <div className="col-md-6">
                                                <label className="form-control-label">
                                                    सन्चाल समिति भए समितिको नाम
                                                    उल्लेख गर्नुहोस्
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="सन्चाल समिति भए समितिको नाम उल्लेख गर्नुहोस्"
                                                    name="committeeName"
                                                    onChange={handleChange}
                                                    value={values.committeeName}
                                                />
                                                <ErrorMessage
                                                    className="invalid-feedback"
                                                    name="committeeName"
                                                    component="div"
                                                />
                                            </div>
                                        )}

                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                सन्चाल समितिमा कति सदस्य रहनु
                                                भएको छ ?
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="सन्चाल समितिमा कति सदस्य रहनु भएको छ ?"
                                                name="capacity"
                                                onChange={handleChange}
                                                value={values.capacity}
                                            />
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="capacity"
                                                component="div"
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                स्रोत व्यक्तिको नाम थर
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="स्रोत व्यक्तिको नाम थर"
                                                name="sponsorPersonInfoName"
                                                onChange={handleChange}
                                                value={
                                                    values.sponsorPersonInfoName
                                                }
                                            />
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="sponsorPersonInfoName"
                                                component="div"
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                सम्पर्क व्यक्तिको सम्पर्क नम्बर
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="सम्पर्क व्यक्तिको सम्पर्क नम्बर"
                                                name="sponsorPersonInfoContact"
                                                onChange={handleChange}
                                                value={
                                                    values.sponsorPersonInfoContact
                                                }
                                            />
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="sponsorPersonInfoContact"
                                                component="div"
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                सम्बन्धी ऐतिहासिक किंवदन्ती
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="सम्बन्धी ऐतिहासिक किंवदन्ती"
                                                name="historicalLegend"
                                                onChange={handleChange}
                                                value={values.historicalLegend}
                                            />
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="historicalLegend"
                                                component="div"
                                            />
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-md-6">
                                                <label className="form-control-label">
                                                    अक्षांश
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="lat"
                                                    onChange={handleChange}
                                                    value={values.geo?.lat}
                                                />
                                                <ErrorMessage
                                                    className="invalid-feedback"
                                                    name="lat"
                                                    component="div"
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-control-label">
                                                    देशान्तर
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="lng"
                                                    onChange={handleChange}
                                                    value={values.geo?.lng}
                                                />
                                                <ErrorMessage
                                                    className="invalid-feedback"
                                                    name="lng"
                                                    component="div"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <label>फोटो</label>
                                            <ImageUploader
                                                fileListContent={
                                                    props.fileListContent
                                                }
                                            />
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="card-footer text-right">
                                        <FormFooterButtons />
                                    </div>
                                </Card.Body>
                            </Card>
                        </form>
                    </>
                )}
            </Formik>
        </div>
    );
};

export default HistoricalReligiousSite;
